<script setup>
import { useRoute, useRouter } from 'vue-router';

const route = useRoute();
const router = useRouter();

const getBreadcrumb = () => {
    const breadcrumbs = [];
    // 添加根目錄
    breadcrumbs.push({
        title: '管理後台',
        path: '/dashboard'
    });

    // 獲取當前路由的 matched 數組
    const matched = route.matched;
    let currentPath = '';

    // 從 matched 中獲取路由信息
    matched.forEach((item) => {
        // 跳過根路由
        if (item.path === '/') return;

        // 處理子路由
        if (item.meta && item.meta.title) {
            // 如果有 redirect，優先使用 redirect
            const path =
                item.redirect ||
                (item.path.startsWith('/')
                    ? item.path
                    : `${currentPath}/${item.path}`);

            // 更新當前路徑
            currentPath = path;

            breadcrumbs.push({
                title: item.meta.title,
                path: path
            });
        }
    });

    return breadcrumbs;
};
</script>

<template>
    <div class="mb-2">
        <a-breadcrumb class="vaporwave-breadcrumb">
            <a-breadcrumb-item
                v-for="(item, index) in getBreadcrumb()"
                :key="index"
            >
                <router-link
                    :to="item.path"
                    @click="
                        index === getBreadcrumb().length - 1
                            ? $event.preventDefault()
                            : null
                    "
                >
                    <span
                        :class="{
                            'hover:text-gray-700':
                                item.title !== $route.meta.title,
                            'text-gray-500':
                                index !== getBreadcrumb().length - 1 &&
                                item.title !== $route.meta.title,
                            'text-gray-800 font-medium':
                                index === getBreadcrumb().length - 1 ||
                                item.title === $route.meta.title,
                            'cursor-default':
                                index === getBreadcrumb().length - 1
                        }"
                    >
                        {{ item.title }}
                    </span>
                </router-link>
            </a-breadcrumb-item>
        </a-breadcrumb>
    </div>
</template>

<style scoped>
/* 蒸氣波風格麵包屑 - 保持原本尺寸和邏輯 */
.vaporwave-breadcrumb {
    font-size: 14px;
    line-height: 1.5;
    background: transparent;
}

:deep(.ant-breadcrumb) {
    color: #4a4a5a;
    background: transparent;
}

:deep(.ant-breadcrumb-separator) {
    color: #8a7a9a;
    margin: 0 8px;
}

:deep(.ant-breadcrumb-link) {
    color: inherit;
    transition: all 0.3s ease;
}

:deep(.ant-breadcrumb-link:hover) {
    color: #2a2a3a;
}

:deep(.ant-breadcrumb-link a) {
    color: inherit;
    transition: all 0.3s ease;
}

:deep(.ant-breadcrumb-link a:hover) {
    color: #2a2a3a;
}

/* 自定義顏色類別 */
.text-aqua-cyan {
    color: #4a4a5a !important;
}

.hover\:text-aqua-cyan:hover {
    color: #2a2a3a !important;
}

.text-gray-400 {
    color: #8a7a9a !important;
}

.font-medium {
    font-weight: 500;
}

.cursor-default {
    cursor: default;
}
</style>
